import { useState } from 'react';
import { testimonials } from '../../../mocks/testimonials';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentIndex + i) % testimonials.length;
      visible.push(testimonials[index]);
    }
    return visible;
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-nature-green text-sm font-semibold uppercase tracking-wider mb-3">
            Testemunhos
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-navy-blue mb-4">
            O Que Dizem os Nossos <span className="font-serif italic">Hóspedes</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Mais de 500 avaliações com classificação média de 4.9 estrelas
          </p>
        </div>

        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {getVisibleTestimonials().map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-gold-accent text-lg"></i>
                  ))}
                </div>

                <p className="text-gray-700 italic text-base leading-relaxed mb-6">
                  "{testimonial.comment}"
                </p>

                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full overflow-hidden bg-gray-200">
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <h4 className="font-bold text-navy-blue">{testimonial.name}</h4>
                      <span className="text-xl">{testimonial.country}</span>
                    </div>
                    <p className="text-sm text-gray-500">Via {testimonial.platform}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-lg hover:bg-sea-blue hover:text-white transition-all cursor-pointer"
            aria-label="Anterior"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-lg hover:bg-sea-blue hover:text-white transition-all cursor-pointer"
            aria-label="Próximo"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <div className="flex items-center justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-sea-blue w-8' : 'bg-gray-300'
                }`}
                aria-label={`Ir para slide ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;